import { apiUrl } from 'store/api';
import { token } from 'store/slices/token';

function downloadFile(blob: Blob, name = 'attendance-allowance.pdf') {
  const href = URL.createObjectURL(blob);
  const a = Object.assign(document.createElement('a'), {
    href,
    style: 'display:none',
    download: name,
  });
  document.body.appendChild(a);
  a.click();
  URL.revokeObjectURL(href);
  a.remove();
}

export async function generatePdf(careProfileId: string) {
  const accessToken = await token.getToken()();

  const response = await fetch(
    `${apiUrl}/v1/care-profile/${careProfileId}/pdf`,
    {
      method: 'POST',
      credentials: 'include',
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({}),
    },
  );

  if (!response.ok) {
    throw new Error(`PDF generation failed with status ${response.status}`);
  }

  const blob = await response.blob();
  downloadFile(blob);
}
